import React, { Component } from 'react';
import { Switch, BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import { observer } from 'mobx-react';
import AuthenticationStore from './AuthenticationStore';
import { AuthStoreContext } from './AppContexts';

import Main from './Main';
import { LoginComponent, RequestPasswordResetComponent, PasswordResetComponent } from './LoginComponent';
import config from './Config';
import './App.css';

class App extends Component {
	authStore = new AuthenticationStore();

	constructor() {
		super();
		console.log('creo');
	}

	render() {
		return (
		<AuthStoreContext.Provider value={this.authStore}>
			<Router basename={config.MOUNT_POINT}>
				<div className="App">
					<Switch>
						<Route exact path='/login' component={LoginComponent} />
						<Route exact path='/password-forgot' component={RequestPasswordResetComponent} />
						<Route exact path='/password-reset' component={PasswordResetComponent} />
						<PrivateRoute path='/' component={Main} />
					</Switch>
				</div>
			</Router>
		</AuthStoreContext.Provider>
		);
	}
}

const PrivateRoute = ({ component: Component, ...rest }) => {
	return (
		<AuthStoreContext.Consumer>
		{ authStore => (
			<Route {...rest} 
			 render={ (props) => {
				return authStore.isLogged ? (
					<Component {...props} authStore={authStore} />
				) : (
					//The state object can be accessed via this.props.location.state in the redirected-to component.
					<Redirect to={{ pathname: "/login", state: { from: props.location } }} />
				) }
			}
		/>) }
		</AuthStoreContext.Consumer>
	);
}

export default App;
